__turbopack_context__.v({
  "bodyParagraph": "HeroBanner-module__vgo00G__bodyParagraph",
  "breadcrumbCurrent": "HeroBanner-module__vgo00G__breadcrumbCurrent",
  "breadcrumbItem": "HeroBanner-module__vgo00G__breadcrumbItem",
  "breadcrumbLink": "HeroBanner-module__vgo00G__breadcrumbLink",
  "breadcrumbList": "HeroBanner-module__vgo00G__breadcrumbList",
  "breadcrumbs": "HeroBanner-module__vgo00G__breadcrumbs",
  "centerAlign": "HeroBanner-module__vgo00G__centerAlign",
  "container": "HeroBanner-module__vgo00G__container",
  "copy": "HeroBanner-module__vgo00G__copy",
  "cta": "HeroBanner-module__vgo00G__cta",
  "ctaButton": "HeroBanner-module__vgo00G__ctaButton",
  "ctaParagraph": "HeroBanner-module__vgo00G__ctaParagraph",
  "ctaPrimary": "HeroBanner-module__vgo00G__ctaPrimary",
  "ctaSecondary": "HeroBanner-module__vgo00G__ctaSecondary",
  "eyebrow": "HeroBanner-module__vgo00G__eyebrow",
  "heading": "HeroBanner-module__vgo00G__heading",
  "hero": "HeroBanner-module__vgo00G__hero",
  "leftAlign": "HeroBanner-module__vgo00G__leftAlign",
  "media": "HeroBanner-module__vgo00G__media",
  "mediaImage": "HeroBanner-module__vgo00G__mediaImage",
  "splitHero": "HeroBanner-module__vgo00G__splitHero",
  "subtitle": "HeroBanner-module__vgo00G__subtitle",
});
